import React, { Fragment, Component } from 'react';
import ArticleCard from './ArticleCard';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import { NavLink } from 'redux-first-router-link';
import { getFileName, truncate, isValid, isText, segmentTrackEvent, decodeSpecialCharacters } from '../../utils';
import { SITE_HOST } from '../../consts';
import './lander-pw.scss';


class CarouselArrow extends React.Component {
  render() {
    const { direction, previousSlide, nextSlide, currentSlide, slidesToShow, slideCount } = this.props;

    const isInactive = (direction === 'prev' && currentSlide === 0) || (direction === 'next' && (slideCount - slidesToShow <= currentSlide) );
    const carouselArrowClassName = `carousel-arrow carousel-arrow-${direction} ${isInactive ? "inactive" : ""}`;

    return (
      <div className={carouselArrowClassName} onClick={() => !isInactive && (direction === 'prev' ? previousSlide() : nextSlide())}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    );
  }
}


class ArticlePickers extends Component {
  constructor() {
    super();
    this.renderList = this.renderList.bind(this);
    this.renderStandard = this.renderStandard.bind(this);
    this.renderCarousel = this.renderCarousel.bind(this);
  }

  renderList(header, articles, blurb, isMobile, adUnit, shouldDisplayAds, isClient) {
    const decodedBlurb = decodeSpecialCharacters(blurb);
    const renderedArticleCards = isValid(articles) ? articles.map((article, i) => {
        if (!isValid(article)) {
          return null;
        }
        const isRecipeArticle = article.category === "recipes";
        const articleUrl = isRecipeArticle ? `${SITE_HOST}/${article.url}` : `/${article.url}`;

        return (
          <div className='list-article'>
            <div className="list-article-num">{i+1}.</div>
            <div className="list-article-text">
              <div className="list-article-category">{article.category}<span>/ {article.authorName}</span></div>
              {isRecipeArticle ? (
                <a 
                  className='list-article-headline'
                  href={articleUrl}>
                    <h3 className="header-text">{article.headline}</h3>
                </a>
              ) : (
                <NavLink 
                  className='list-article-headline'
                  to={articleUrl}>
                    <h3 className="header-text">{article.headline}</h3>
                </NavLink>
              )}
            </div>
          </div>
        );
      }) : null;

      return (
        <div className="vertical-section-list col-10 col-4-sm">
          <h2 className='section-hed-list' dangerouslySetInnerHTML={{ __html: header }}></h2>
          {isValid(blurb) && <div className='section-blurb' dangerouslySetInnerHTML={{ __html: decodedBlurb }}/> }
          <div className='list-articles'>
            {renderedArticleCards}
          </div>
        </div>
      );
  }

  renderCarousel(header, articles, blurb, isMobile, adUnit, shouldDisplayAds, isClient) {
      
      const renderedArticleCards = isValid(articles) ? articles.map((article, i) => {
        article.cardClass = "big-card";
        return (
          <ArticleCard key={i} data={article} isMobile={isMobile} shouldDisplaySponsored={true} showCategory={true} isCarousel={true} isClient={isClient}/>
        );
      }) : null;

      const carouselProps = {
        dragging: false,
        swipping: false,
        slidesToScroll: isMobile ? 1 : 3,
        slidesToShow: isMobile ? 1.35 : 3,
        heightMode: 'max',
        previousDisabled: true,
        renderBottomCenterControls: false,
        wrapAround: false,
      };

      return (
        <div className="vertical-section-carousel">
          <div className="vertical-carousel-wrapper col-12">
            <div className="vertical-carousel-text col-3 col-4-sm">
              <h2 className='section-hed-carousel' dangerouslySetInnerHTML={{ __html: header }}></h2>
              <div className='carousel-hr'/>
              {isValid(blurb) && <div className='section-blurb' dangerouslySetInnerHTML={{ __html: blurb }}/> }
            </div>
            <Carousel
              className="article-carousel"
              renderCenterLeftControls={props => (<CarouselArrow direction="prev" {...props} />)}
              renderCenterRightControls={props => (<CarouselArrow direction="next" {...props} />)}
              {...carouselProps}>
                  {renderedArticleCards}
            </Carousel>
          </div>
        </div>
      );
  }

  renderStandard(header, articles, blurb, isMobile, adUnit, shouldDisplayAds, isClient) {
      const renderedArticleCards = isValid(articles) ? articles.map((article, i) => {
        article.cardClass = "big-card";
        return (
          <ArticleCard key={i} data={article} isMobile={isMobile} shouldDisplaySponsored={true} showCategory={true} isClient={isClient}/>
        );
      }) : null;
      const decodedBlurb = decodeSpecialCharacters(blurb);

      return (
        <div className="vertical-section col-12 col-4-sm">
          <h2 className='section-hed' dangerouslySetInnerHTML={{ __html: header }}></h2>
          {isValid(blurb) && <div className='section-blurb' dangerouslySetInnerHTML={{ __html: decodedBlurb }}/> }
          <div className='category-hr'/>
          <div className='article-cards'>
            {renderedArticleCards}
          </div>
        </div>
      );
  }

  render() {
    const { articles, header, blurb, pickerType, isMobile, adUnit, shouldDisplayAds, isClient } = this.props;

    let renderedArticlePicker = null;

    switch (pickerType) {
      case 'list':
        renderedArticlePicker = this.renderList(header, articles, blurb, isMobile, adUnit, shouldDisplayAds, isClient);
        break;
      case 'carousel':
        renderedArticlePicker = this.renderCarousel(header, articles, blurb, isMobile, adUnit, shouldDisplayAds, isClient);
        break;
      case 'standard':
        renderedArticlePicker = this.renderStandard(header, articles, blurb, isMobile, adUnit, shouldDisplayAds, isClient);
        break;
      default:
        renderedArticlePicker = null;
    }

    return (
        <Fragment>
            {renderedArticlePicker}
        </Fragment>
    );
  };
}


export default ArticlePickers;
